(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodDropdownMenu', sodDropdownMenu);

    function sodDropdownMenu($document) {
        return {
            restrict: "EA",
            link: link
        };

        function link(scope, elem) {
            scope.active = false;

            elem.on('click', toggleClassHandler);

            $document.on('click', ':not(.nav-bar-dropdown a)',removeClassHandler);

            scope.$on('$destroy', function () {
                $document.off('click', removeClassHandler);
                elem.off('click', toggleClassHandler);
            });

            function toggleClassHandler() {
                elem.toggleClass('active');
                toggleActiveVar();
            }

            function removeClassHandler(e) {
                var eventOutsideTarget = (elem[0] !== e.target) && (0 === elem.find(e.target).length);
                if (eventOutsideTarget) {
                    elem.removeClass('active');
                    toggleActiveVar();
                }

            }

            function toggleActiveVar() {
                scope.active = elem.hasClass('active');
                scope.$apply();
            }

        }
    }
})();